export { default } from './Blog.component';
